{
  "name": "@shopify/hydrogen-react",
  "version": "2026.4.3",
  "description": "React components, hooks, and utilities for creating custom Shopify storefronts",
  "homepage": "https://github.com/Shopify/hydrogen/tree/main/packages/hydrogen-react",
  "license": "MIT",
  "publishConfig": {
    "access": "public",
    "@shopify:registry": "https://registry.npmjs.org"
  },
  "files": [
    "dist",
    "storefront.schema.json",
    "customer-account.schema.json"
  ],
  "type": "commonjs",
  "exports": {
    ".": {
      "node": {
        "require": {
          "types": "./dist/types/index.d.cts",
          "development": "./dist/node-dev/index.js",
          "default": "./dist/node-prod/index.js"
        },
        "import": {
          "types": "./dist/types/index.d.ts",
          "development": "./dist/node-dev/index.mjs",
          "default": "./dist/node-prod/index.mjs"
        },
        "default": "./dist/node-prod/index.js"
      },
      "module": {
        "types": "./dist/types/index.d.ts",
        "development": "./dist/browser-dev/index.mjs",
        "default": "./dist/browser-prod/index.mjs"
      },
      "import": {
        "types": "./dist/types/index.d.ts",
        "development": "./dist/browser-dev/index.mjs",
        "default": "./dist/browser-prod/index.mjs"
      },
      "require": {
        "types": "./dist/types/index.d.cts",
        "development": "./dist/node-dev/index.js",
        "default": "./dist/node-prod/index.js"
      },
      "default": "./dist/browser-prod/index.mjs"
    },
    "./storefront-api-types": "./dist/types/storefront-api-types.d.ts",
    "./storefront.schema.json": "./storefront.schema.json",
    "./customer-account.schema.json": "./customer-account.schema.json",
    "./customer-account-api-types": "./dist/types/customer-account-api-types.d.ts",
    "./package.json": "./package.json",
    "./*": {
      "node": {
        "require": {
          "types": "./dist/types/*.d.cts",
          "development": "./dist/node-dev/*.js",
          "default": "./dist/node-prod/*.js"
        },
        "import": {
          "types": "./dist/types/*.d.ts",
          "development": "./dist/node-dev/*.mjs",
          "default": "./dist/node-prod/*.mjs"
        },
        "default": "./dist/node-prod/*.js"
      },
      "module": {
        "types": "./dist/types/*.d.ts",
        "development": "./dist/browser-dev/*.mjs",
        "default": "./dist/browser-prod/*.mjs"
      },
      "import": {
        "types": "./dist/types/*.d.ts",
        "development": "./dist/browser-dev/*.mjs",
        "default": "./dist/browser-prod/*.mjs"
      },
      "require": {
        "types": "./dist/types/*.d.cts",
        "development": "./dist/node-dev/*.js",
        "default": "./dist/node-prod/*.js"
      },
      "default": "./dist/browser-prod/*.mjs"
    }
  },
  "typesVersions": {
    "*": {
      "storefront-api-types": [
        "./dist/types/storefront-api-types.d.ts"
      ]
    }
  },
  "main": "./dist/node-prod/index.js",
  "module": "./dist/node-prod/index.mjs",
  "browser": "./dist/browser-prod/index.mjs",
  "types": "./dist/types/index.d.ts",
  "unpkg": "./dist/umd/hydrogen-react.prod.js",
  "jsdelivr": "./dist/umd/hydrogen-react.prod.js",
  "sideEffects": false,
  "scripts": {
    "build-docs": "sh ./docs/build-docs.sh && pnpm run format",
    "clean-dist": "rimraf ./dist",
    "dev": "run-s dev:demo",
    "dev:story": "ladle serve",
    "dev:demo": "run-p dev:demo:* copy-api-types",
    "dev:demo:browser-dev": "vite build --watch --emptyOutDir false --clearScreen false --mode devbuild",
    "dev:demo:ts": "tsc --watch --emitDeclarationOnly",
    "build": "npm-run-all --sequential clean-dist --parallel build:vite:* build:tsc:es --parallel build:tsc:cjs copy-api-types",
    "build:vite:browser-dev": "vite build --mode devbuild",
    "build:vite:browser-prod": "vite build",
    "build:vite:node-dev": "vite build --mode devbuild --ssr",
    "build:vite:node-prod": "vite build --ssr",
    "build:vite:umddev": "vite build --mode umdbuilddev",
    "build:vite:umdprod": "vite build --mode umdbuild",
    "build:tsc:cjs": "cpy ./dist/types/index.d.ts ./dist/types/ --rename=index.d.cts --flat",
    "build:tsc:es": "tsc --emitDeclarationOnly --project tsconfig.typeoutput.json",
    "copy-api-types": "cpy ./src/storefront-api-types.d.ts ./src/customer-account-api-types.d.ts ./dist/types/ --flat",
    "format": "prettier --write \"{src,docs}/**/*\" --ignore-unknown",
    "graphql-types": "graphql-codegen --config codegen.ts && pnpm run format",
    "test": "vitest run --coverage",
    "test:watch": "vitest",
    "typecheck": "run-p typecheck:*",
    "typecheck:code": "tsc --noEmit",
    "typecheck:examples": "tsc --noEmit --project tsconfig.examples.json",
    "preview-docs": "pnpm --dir ../../docs/preview run dev"
  },
  "devDependencies": {
    "@faker-js/faker": "^9.4.0",
    "@graphql-codegen/add": "^5.0.3",
    "@graphql-codegen/cli": "^5.0.4",
    "@graphql-codegen/introspection": "^4.0.3",
    "@graphql-codegen/typescript": "^4.1.3",
    "@ladle/react": "^5.0.1",
    "@shopify/generate-docs": "catalog:",
    "@testing-library/jest-dom": "^6.6.3",
    "@testing-library/react": "^14.0.0",
    "@testing-library/user-event": "^14.6.1",
    "@types/react": "catalog:",
    "@types/react-dom": "catalog:",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^3.2.4",
    "cpy-cli": "^5.0.0",
    "eslint": "9.19.0",
    "eslint-config-prettier": "10.0.1",
    "eslint-import-resolver-typescript": "3.7.0",
    "eslint-plugin-eslint-comments": "3.2.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jest": "28.11.0",
    "eslint-plugin-jsx-a11y": "6.10.2",
    "eslint-plugin-node": "11.1.0",
    "eslint-plugin-prettier": "4.2.1",
    "eslint-plugin-react": "7.37.4",
    "eslint-plugin-react-hooks": "5.1.0",
    "eslint-plugin-simple-import-sort": "12.1.1",
    "eslint-plugin-tsdoc": "0.2.14",
    "happy-dom": "^20.8.9",
    "npm-run-all": "^4.1.5",
    "react": "catalog:",
    "react-dom": "catalog:",
    "rimraf": "^6.0.1",
    "ts-expect": "^1.3.0",
    "typescript": "5.9.2",
    "vite": "^8.0.1",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "react": "^18.3.1 || ~19.0.3 || ~19.1.4 || ^19.2.3",
    "react-dom": "^18.3.1 || ~19.0.3 || ~19.1.4 || ^19.2.3",
    "vite": "^5.1.0 || ^6.2.1 || ^7.0.0 || ^8.0.0"
  },
  "dependencies": {
    "@google/model-viewer": "^4.0.0",
    "@xstate/fsm": "2.0.0",
    "ast-v8-to-istanbul": "^0.3.11",
    "graphql": "^16.10.0",
    "type-fest": "^4.33.0",
    "worktop": "^0.7.3"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/Shopify/hydrogen.git",
    "directory": "packages/hydrogen-react"
  },
  "bugs": "https://github.com/shopify/hydrogen/issues"
}
